import img1 from "./images/diver-turtle.jpeg";
import img2 from "./images/cenote-tour.jpeg";
import img3 from "./images/koox-ich-cool.jpeg";
import img4 from "./images/beach.jpeg";
import img5 from "./images/los-colibres.jpeg";
import img6 from "./images/live-music.jpg";

export const pageLinks = [
  {
    id: 1,
    href: "#home",
    text: "home",
  },
  {
    id: 2,
    href: "#sleep",
    text: "sleep",
  },
  {
    id: 3,
    href: "#play",
    text: "play",
  },
  {
    id: 4,
    href: "#eat",
    text: "eat",
  },
  {
    id: 5,
    href: "#book",
    text: "book",
  },
];

export const activities = [
  {
    id: 6,
    image: img1,
    source: "omdelfin",
    icon: "fa-solid fa-fish",
    title: "scuba diving tours",
    text: "Puerto Morelos is home to the best preserved section of the Mesoamerican Barrier Reef. This part of the second largest barrier reef in the world is also closer to land in Puerto Morelos than anywhere else in Mexico. You can't miss diving and snorkeling in Puerto Morelos! Courses, dive and snorkeling tour packages available at OmDelfin.",
    href: "https://omdelfin.com/",
    name: "Dive Shop OmDelfin",
    price: "from $90",
  },
  {
    id: 7,
    image: img2,
    source: "layla guesthouse",
    icon: "fa-solid fa-binoculars",
    title: "jungle and cenote tours",
    text: "The explorer in you can't miss enyoying the various cenotes, which are fresh water sinkholes found in the middle of the jungle. Along the Ruta de los Cenotes you can find a variety of cenotes that are both completely open, semi-open or in a cavern. Join the Layla Guesthouse Mayan Experience Cenote tour for a once in a lifetime jungle and cenote experience.",
    href: "https://laylaguesthouse.com/cenote-tour/",
    name: "Layla Guesthouse",
    price: "from $120",
  },
  {
    id: 8,
    image: img3,
    source: "kookichcool",
    icon: "fa-solid fa-utensils",
    title: "organic mexican food",
    text: "Koox Ich Kool is an organic experience along the Ruta de los Cenotes. Hosted by chef Karla Romo on her organic farm, she prepares a 6-course buffet meal using the finest local and organic ingredients along with a selection of mezcal and wine from Valle de Guadalupe. You'll also tour the orchard, the jungle and enjoy the water of the cenote pool.",
    href: "https://www.facebook.com/kooxichkool",
    name: "Koox Ich Kool",
    price: "Contact for price",
  },
  {
    id: 9,
    image: img4,
    source: "pexels",
    icon: "fa-solid fa-umbrella-beach",
    title: "Beach Clubs",
    text: "Puerto Morelos has numerous beach clubs and the cost to rent a chair is very affordable. Although you can just bring your towel and lounge around for free, having a drink, food and a relaxing chair is worth it. Among our favorites include Hotel Ojo de Agua beach club, My Paradise, Don Ernesto's and the Diving Lodge.",
    href: "https://www.google.com/",
    name: "search google",
    price: "from $10",
  },
  {
    id: 10,
    image: img5,
    source: "Los Colibries",
    icon: "fa-solid fa-spa",
    title: "Mayan Jungle Spa",
    text: "Los Colibries is a unique Mayan jungle spa along the Ruta de los Cenotes. The spa offers an exotic environment, surrounded by hundreds of trees, tropical plants, and birds. Their expert massage therapists provide traditional mayan massages, an outdoor bath all with natural oils. You'll have the most relaxing experience, guaranteed!",
    href: "https://loscolibries.mx/",
    name: "Los Colibres",
    price: "from $50",
  },
  {
    id: 11,
    image: img6,
    source: "Pexels",
    icon: "fa-solid fa-guitar",
    title: "live music",
    text: "You'll find numerous street musicians and live bands performing in and out of the various restaurants along Puerto Morelos' beach side. From traditional mariachi to rock and roll and even karaoke, you'll surely find very entertaining music. Just do a Google search of live music in Puerto Morelos to get the latest information.",
    href: "https://www.google.com/search?q=best+live+music+in+puerto+morelos&source=lmns&bih=969&biw=1920&hl=en&sa=X&ved=2ahUKEwiVyfbl__D9AhVeL94AHU9UDMoQ_AUoAHoECAEQAA",
    name: "search google",
    price: "inquire at venue",
  },
];

export const cafeList = [
  {
    id: 11,
    href: "https://www.facebook.com/groups/463890004516990/posts/702000470705941/",
    restaurant: "Cafe Amancia",
  },
  {
    id: 12,
    href: "https://laylaguesthouse.com/es/cafe-layla-menu/",
    restaurant: "Cafe Layla",
  },
  {
    id: 13,
    href: "https://www.tripadvisor.com/Restaurant_Review-g240327-d23727568-Reviews-Cecilia_Bakes_Coffee_Shop-Puerto_Morelos_Yucatan_Peninsula.html",
    restaurant: "Cecilia Bakes",
  },
  {
    id: 14,
    href: "https://pm.eliniciorestaurante.com/",
    restaurant: "El Inicio",
  },
  {
    id: 15,
    href: "https://www.facebook.com/groups/463890004516990/posts/702000470705941/",
    restaurant: "Cafe Amancia",
  },
  {
    id: 16,
    href: "https://www.google.com/search?q=oneida%20cafe%20puerto%20morelos&oq=oneida+cafe+puerto+&aqs=chrome.1.69i57j33i160l2.7684j0j4&sourceid=chrome&ie=UTF-8&tbs=lf:1,lf_ui:9&tbm=lcl&sxsrf=AJOqlzVj4mMUDrbRNVXH9IExd6_X0ilrUg:1679427415137&rflfq=1&num=10&rldimm=17498560580722829126&lqi=ChpvbmVpZGEgY2FmZSBwdWVydG8gbW9yZWxvc0i45JPZg6-AgAhaJhAAEAEYASIab25laWRhIGNhZmUgcHVlcnRvIG1vcmVsb3MyAmVzkgEEY2FmZZoBI0NoWkRTVWhOTUc5blMwVkpRMEZuU1VOQ09IVmZjMEYzRUFFqgE_CgkvbS8wMjBmYjIQASoPIgtvbmVpZGEgY2FmZSgOMh8QASIbgoV4PA3WGqQdX-bucgOUhzTOif14eeiDLw-I&phdesc=4hPtMr2WH8M&ved=2ahUKEwj1j4XU4u39AhUxLkQIHaqiBMQQvS56BAgYEAE&sa=X&rlst=f#rlfi=hd:;si:17498560580722829126,l,ChpvbmVpZGEgY2FmZSBwdWVydG8gbW9yZWxvc0i45JPZg6-AgAhaJhAAEAEYASIab25laWRhIGNhZmUgcHVlcnRvIG1vcmVsb3MyAmVzkgEEY2FmZZoBI0NoWkRTVWhOTUc5blMwVkpRMEZuU1VOQ09IVmZjMEYzRUFFqgE_CgkvbS8wMjBmYjIQASoPIgtvbmVpZGEgY2FmZSgOMh8QASIbgoV4PA3WGqQdX-bucgOUhzTOif14eeiDLw-I,y,4hPtMr2WH8M;mv:[[20.8748708,-86.87257199999999],[20.831762599999998,-86.9025786]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!1m4!1u2!2m2!2m1!1e1!2m1!1e2!2m1!1e3!2m4!1e17!4m2!17m1!1e2!3sIAE,lf:1,lf_ui:9",
    restaurant: "Eneida Cafe",
  },
  {
    id: 17,
    href: "https://www.estacion69.com/",
    restaurant: "Estacion 69",
  },
  {
    id: 18,
    href: "https://localcofffeshop.wordpress.com/",
    restaurant: "Local Coffee Shop",
  },
  {
    id: 19,
    href: "https://www.facebook.com/lolaymoya/?locale=es_LA",
    restaurant: "Lola Y Moya",
  },
  {
    id: 20,
    href: "https://www.facebook.com/mangatapuertomorelos",
    restaurant: "Mangata",
  },
  {
    id: 21,
    href: "https://www.estacion69.com/",
    restaurant: "Estacion 69",
  },
];

export const mexFoodList = [
  {
    id: 111,
    href: "https://www.facebook.com/ElNichoPM/",
    restaurant: "El Nicho",
  },
  {
    id: 112,
    href: "https://www.facebook.com/profile.php?id=100063548470071",
    restaurant: "La Cabaña",
  },
  {
    id: 113,
    href: "https://www.facebook.com/ElNichoPM/",
    restaurant: "El Nicho",
  },
  {
    id: 114,
    href: "https://www.facebook.com/lachozadelpuerto/",
    restaurant: "La Choza",
  },
  {
    id: 115,
    href: "https://www.tripadvisor.com/Restaurant_Review-g240327-d12396192-Reviews-Las_Koras-Puerto_Morelos_Yucatan_Peninsula.html",
    restaurant: "Las Koras",
  },
  {
    id: 116,
    href: "https://www.facebook.com/pecaofondademar/",
    restaurant: "Pecao",
  },
  {
    id: 117,
    href: "https://www.facebook.com/SocioNaizPuertoMorelos/",
    restaurant: "Socio Naiz",
  },
  {
    id: 118,
    href: "https://www.facebook.com/profile.php?id=100063965113592",
    restaurant: "taco.com",
  },
  {
    id: 119,
    href: "https://www.facebook.com/people/Taquer%C3%ADa-El-Mariachi/100063789630051/?paipv=0&eav=Afaeu87_REEGhYUlNEP5RqHoJ103i2t7_j4vS2qpJHM_Mj88n0uPce6pGdPnfih0FFA&_rdr",
    restaurant: "Taqueria El Mariachi",
  },
  {
    id: 120,
    href: "https://www.tripadvisor.com/Restaurant_Review-g240327-d16738846-Reviews-Taqueria_Neza-Puerto_Morelos_Yucatan_Peninsula.html",
    restaurant: "Taqueria Neza",
  },
  {
    id: 121,
    href: "https://www.facebook.com/VeggieVeggieStreetFood",
    restaurant: "Veggie Veggie Street Food",
  },
];

export const intlFoodList = [
  {
    id: 222,
    href: "https://www.facebook.com/Daipuertomorelos/?locale=es_LA",
    restaurant: "Dai Smokehouse and Sake",
  },
  {
    id: 223,
    href: "https://www.facebook.com/doragonrestaurantejapones",
    restaurant: "Doragon Sushi",
  },
  {
    id: 224,
    href: "https://www.facebook.com/groups/463890004516990/posts/702000470705941/",
    restaurant: "El Campanario",
  },
  {
    id: 225,
    href: "https://www.tripadvisor.com.mx/Restaurant_Review-g240327-d1051278-Reviews-El_Pirata-Puerto_Morelos_Yucatan_Peninsula.html",
    restaurant: "El Pirata",
  },
  {
    id: 226,
    href: "https://www.facebook.com/ruta40puertomorelos/",
    restaurant: "Empanadas Ruta 40",
  },
  {
    id: 227,
    href: "https://www.facebook.com/iwannapizza/",
    restaurant: "I Wanna Pizza",
  },
  {
    id: 228,
    href: "https://www.memalmare.com/",
    restaurant: "Mem Al Mare",
  },
  {
    id: 229,
    href: "https://taninosrestaurant.com/",
    restaurant: "Tanino's",
  },
  {
    id: 230,
    href: "https://restaurantesenpuertomorelos.com/establecimiento/yum-yum-wok/",
    restaurant: "Yum Yum Wok",
  },
];

export const fishFoodList = [
  {
    id: 333,
    href: "https://www.facebook.com/BLUE.MORELOS/?locale=es_LA",
    restaurant: "Blue",
  },
  {
    id: 334,
    href: "https://www.facebook.com/BoquinetePuerto/",
    restaurant: "Boquinete Seafood & Grill",
  },
  {
    id: 335,
    href: "https://www.facebook.com/elpesqueropuertomorelos/reviews",
    restaurant: "El Pesquero",
  },
  {
    id: 336,
    href: "https://lasirenapm.com/",
    restaurant: "La Sirena",
  },
  {
    id: 337,
    href: "http://muelleonce.com/",
    restaurant: "Muelle Once",
  },
  {
    id: 338,
    href: "https://playajaguar.com/inicio/",
    restaurant: "Playa Jaguar",
  },
  {
    id: 339,
    href: "https://bullandtank.com/punta-corcho",
    restaurant: "Punta Corcho",
  },
];

export const sleepItems = [
  {
    id: 444,
    icon: "fa-solid fa-umbrella-beach fa-fw",
    title: "beachfront",
    text: "Located across from the beach and two blocks from the town center, this one-bedroom one bath apartment is perfect for two guests.",
  },
  {
    id: 445,
    icon: "fa-solid fa-unlock fa-fw",
    title: "self check-in",
    text: "Secure lockbox with keys allows guests to check-in and out on their own. Combination and additional details will be provided upon booking.",
  },
  {
    id: 446,
    icon: "fa-solid fa-wifi fa-fw",
    title: "dedicated workspace",
    text: "Collapsible work desk with blazing fast fiber-optic wifi (up to 500Mbps) allows reliable internet access, streaming and video conferencing.",
  },
];
